export type SearchMatchSegment = { text: string; isMatch: boolean };

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Splits text into runs that do and do not match a search, ignoring case. Each word of the search
 * matches on its own, as the search results mark them, so "ESR1 camizestrant" marks both words
 * wherever they appear rather than only the exact phrase. Longer words are tried first, so a word
 * that contains another is marked whole.
 *
 * Matching is literal: the search engine also matches typos and word forms, so a result can
 * open an inquiry where nothing is marked.
 */
export function searchMatchSegments(text: string, query: string): SearchMatchSegment[] {
  const words = [...new Set(query.toLowerCase().split(/\s+/).filter(Boolean))].sort(
    (first, second) => second.length - first.length
  );

  if (words.length === 0 || text === '') {
    return [{ text, isMatch: false }];
  }

  const pattern = new RegExp(`(${words.map(escapeRegExp).join('|')})`, 'gi');

  // Splitting on a capturing group puts every match at an odd index.
  return text
    .split(pattern)
    .map((part, index) => ({ text: part, isMatch: index % 2 === 1 }))
    .filter((segment) => segment.text !== '');
}
